export default __webpack_public_path__ + "static/media/icon_cto.afc483d9.png";